module.exports = __webpack_public_path__ + "fonts/fa-light-300.3def2ce.eot";